<template>
  <div class="container">
    <nav class="breadcrumb">
      <a href="/">Home</a>

      <span v-if="showCollection">
        <i class="seperator icon icon-arrow-right" />

        <component
          :is="isCollectionPage ? 'span' : 'a'"
          :href="!isCollectionPage ? collectionData.url : undefined"
        >
          {{ collectionData.name }}
        </component>
      </span>

      <span v-if="!isCollectionPage">
        <i class="seperator icon icon-arrow-right" />
        <span>{{ productTitle }}</span>
      </span>
    </nav>
  </div>
</template>

<script>
import { mapState } from "vuex";
import isEmpty from "lodash-es/isEmpty";

export default {
  name: "Breadcrumbs",
  props: {
    isCollectionPage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localCollectionData: null,
    };
  },
  computed: {
    ...mapState("product", ["product"]),
    ...mapState("collection", ["collection"]),
    productTitle() {
      return this.product.title;
    },
    collectionData() {
      return this.localCollectionData || this.collection;
    },
    showCollection() {
      return !isEmpty(this.collectionData);
    },
  },
  watch: {
    collection(newVal, oldVal) {
      if (isEmpty(oldVal) && newVal) {
        if (this.isCollectionPage) {
          this.storeLocalCollectionData();
        } else {
          this.fetchLocalCollectionData();
        }
      }
    },
  },
  mounted() {
    this.fetchLocalCollectionData(); // Fetch data if available in local storage
  },
  methods: {
    fetchLocalCollectionData() {
      const storedData = localStorage.getItem("breadcrumbCollection");
      if (storedData) {
        this.localCollectionData = JSON.parse(storedData);
        localStorage.removeItem("breadcrumbCollection");
      }
    },
    storeLocalCollectionData() {
      const collectionObject = {
        name: this.collection?.title,
        url: this.collection?.onlineStoreUrl,
      };
      this.localCollectionData = collectionObject;
      localStorage.setItem(
        "breadcrumbCollection",
        JSON.stringify(collectionObject)
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.breadcrumb {
  text-transform: uppercase;
  font-size: 9px;
  font-weight: 700;
  padding-top: 12px;
  padding-bottom: 12px;

  a {
    font-weight: 400;
    text-decoration: none;
  }

  .seperator {
    margin: 0 6px;
  }
}
</style>
